import {useGenericFilters} from 'app/hooks';
import {useAsyncActions} from 'app/utils/redux';

import {convertLocationParamsToFetchParams} from './api';
import {selectProcedureFilters, setProceduresFilters} from './slice';

import type {ProceduresFetchParamsType} from './types';
import type {Location} from 'history';
import type {InjectedRouter} from 'react-router';

export function useProcedureFilters(
  location: Location<ProceduresFetchParamsType>,
  router: InjectedRouter
) {
  return useGenericFilters(
    location,
    router,
    selectProcedureFilters,
    useAsyncActions({
      setProceduresFilters,
    }).setProceduresFilters,
    convertLocationParamsToFetchParams
  );
}
